import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.filters');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-filters',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.filters/view.scss */
:host {
  display: block;
}

.strategy-page {
  animation: strategy-page-in 320ms ease-out both;
  color: #111827;
}

.strategy-hero {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 1.25rem;
  background: #fff;
  padding: 1rem;
  color: #111827;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 2px 8px rgba(15, 23, 42, 0.045), 0 24px 56px rgba(15, 23, 42, 0.075);
}

.strategy-hero__top,
.strategy-overview,
.strategy-note {
  position: relative;
  z-index: 1;
}

.strategy-hero__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.strategy-status-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 999px;
  background: #2f9368;
  box-shadow: 0 0 0 0.25rem rgba(47, 147, 104, 0.1);
}

.strategy-status-label,
.strategy-pass-text {
  color: #237a55;
}

.strategy-block-text {
  color: #b44b55;
}

.strategy-muted {
  color: #8e8e93;
}

.strategy-round {
  color: #8e8e93;
  font-size: 0.6875rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.strategy-overview {
  display: grid;
  gap: 1rem;
  margin-top: 1rem;
}

.strategy-candidate-number {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 0.35rem;
  margin-top: 0.35rem;
  font-size: clamp(2rem, 9vw, 3rem);
  font-weight: 950;
  letter-spacing: -0.055em;
  line-height: 1.08;
}

.strategy-candidate-number small {
  color: #8e8e93;
  font-size: 0.75rem;
  font-weight: 900;
  letter-spacing: 0;
}

.strategy-meter-block {
  margin-top: 0.9rem;
}

.strategy-meter {
  position: relative;
  overflow: hidden;
  height: 0.45rem;
  border-radius: 999px;
  background: #eadadd;
}

.strategy-meter__remaining {
  height: 100%;
  border-radius: inherit;
  background: #49aa81;
  transition: width 550ms cubic-bezier(0.22, 1, 0.36, 1);
}

.strategy-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
  margin-top: 0.85rem;
}

.strategy-summary-grid > div {
  min-width: 0;
  border: 1px solid #e7e7e4;
  border-radius: 0.75rem;
  background: #f8f8f6;
  padding: 0.62rem;
}

.strategy-summary-grid dt {
  color: #8e8e93;
  font-size: 0.625rem;
  font-weight: 800;
}

.strategy-summary-grid dd {
  overflow: hidden;
  margin-top: 0.2rem;
  font-size: clamp(0.75rem, 3.5vw, 0.95rem);
  font-weight: 900;
  letter-spacing: -0.025em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.strategy-history {
  border: 1px solid #e7e7e4;
  border-radius: 1rem;
  background: #f8f8f6;
  padding: 0.85rem;
}

.strategy-history-title {
  color: #111827;
}

.strategy-history__rate {
  color: #9f4450;
  font-size: 0.625rem;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
}

.strategy-history__numbers {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.strategy-history__numbers > div {
  border: 1px solid #e8e8e5;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.65rem;
}

.strategy-history__numbers p {
  color: #8e8e93;
  font-size: 0.625rem;
  font-weight: 800;
}

.strategy-history__numbers strong {
  display: block;
  margin-top: 0.25rem;
  font-size: 1.05rem;
  font-weight: 950;
}

.strategy-history-meter {
  display: flex;
  overflow: hidden;
  height: 0.42rem;
  margin-top: 0.9rem;
  border-radius: 999px;
  background: #e7e7e4;
}

.strategy-history-meter__pass {
  background: #49aa81;
}

.strategy-history-meter__blocked {
  background: #d56c78;
}

.strategy-history__warning {
  margin-top: 0.75rem;
  color: #68686d;
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 1.5;
}

.strategy-note {
  margin-top: 0.75rem;
  border-top: 1px solid #ececea;
}

.strategy-note summary {
  display: flex;
  min-height: 2.75rem;
  cursor: pointer;
  list-style: none;
  align-items: center;
  justify-content: space-between;
  color: #68686d;
  font-size: 0.6875rem;
  font-weight: 900;
}

.strategy-note summary::-webkit-details-marker,
.strategy-filter-card > summary::-webkit-details-marker {
  display: none;
}

.strategy-note summary svg {
  width: 1rem;
  transition: transform 180ms ease;
}

.strategy-note[open] summary svg {
  transform: rotate(180deg);
}

.strategy-note p {
  padding: 0 0 0.75rem;
  color: #68686d;
  font-size: 0.6875rem;
  line-height: 1.65;
}

.strategy-process {
  margin-top: 0.75rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 1.1rem;
  background: #fff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 2px 8px rgba(15, 23, 42, 0.035), 0 12px 30px rgba(15, 23, 42, 0.04);
}

.strategy-filter-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.strategy-process summary::-webkit-details-marker {
  display: none;
}

.strategy-process-summary {
  display: flex;
  min-height: 3.65rem;
  cursor: pointer;
  list-style: none;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.8rem 0.9rem;
}

.strategy-process-summary strong,
.strategy-process-summary span {
  display: block;
}

.strategy-process-summary strong {
  color: #111827;
  font-size: 0.75rem;
  font-weight: 900;
}

.strategy-process-summary span {
  margin-top: 0.12rem;
  color: #8e8e93;
  font-size: 0.625rem;
  font-weight: 700;
}

.strategy-process-summary svg {
  width: 1rem;
  flex: none;
  color: #68686d;
  transition: transform 180ms ease;
}

.strategy-process[open] .strategy-process-summary svg {
  transform: rotate(180deg);
}

.strategy-process-body {
  border-top: 1px solid #ececea;
  padding: 0.75rem 0.85rem 0.85rem;
}

.strategy-flow {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
  margin-top: 0;
}

.strategy-stage {
  position: relative;
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.6rem;
  border-radius: 0.75rem;
  background: #f7f7f5;
  padding: 0.65rem;
}

.strategy-stage > span {
  display: flex;
  width: 1.55rem;
  height: 1.55rem;
  flex: none;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #e9e9e6;
  color: #68686d;
  font-size: 0.625rem;
  font-weight: 950;
}

.strategy-stage strong {
  display: block;
  overflow: hidden;
  color: #1e293b;
  font-size: 0.6875rem;
  font-weight: 950;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.strategy-stage p {
  margin-top: 0.15rem;
  color: #94a3b8;
  font-size: 0.625rem;
  font-weight: 700;
}

.strategy-stage--final {
  background: #f0faf5;
}

.strategy-stage--final > span {
  background: #2f9368;
  color: white;
}

.strategy-category-nav {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.4rem;
  margin: 0.85rem 0;
}

.strategy-category-nav button {
  display: inline-flex;
  min-height: 2.5rem;
  min-width: 0;
  align-items: center;
  gap: 0.45rem;
  border: 1px solid #e4e4e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0 0.65rem;
  color: #68686d;
  font-size: 0.6875rem;
  font-weight: 900;
  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease, transform 160ms ease;
}

.strategy-category-nav button:hover {
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

.strategy-category-nav button.is-active {
  border-color: #18181b;
  background: #18181b;
  color: #fff;
  box-shadow: 0 7px 18px -12px rgba(15, 23, 42, 0.8);
}

.strategy-category-nav small {
  display: flex;
  min-width: 1.25rem;
  height: 1.25rem;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 0.5625rem;
  font-weight: 950;
}

.strategy-category-nav button.is-active small {
  background: rgba(255, 255, 255, 0.13);
  color: #d1fae5;
}

.strategy-filter-grid {
  display: grid;
  overflow: hidden;
  gap: 0;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 1.05rem;
  background: #fff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 2px 8px rgba(15, 23, 42, 0.04), 0 18px 42px rgba(15, 23, 42, 0.055);
}

.strategy-filter-card {
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: #fff;
  transition: background-color 180ms ease;
}

.strategy-filter-card + .strategy-filter-card {
  border-top: 1px solid #ececea;
}

.strategy-filter-card:hover,
.strategy-filter-card[open] {
  background: #fbfbfa;
}

.strategy-filter-card > summary {
  display: flex;
  min-height: 7.4rem;
  cursor: pointer;
  list-style: none;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.8rem;
}

.strategy-filter-card h3 {
  color: #0f172a;
  font-size: 0.75rem;
  font-weight: 950;
  line-height: 1.5;
}

.strategy-filter-state {
  flex: none;
  font-size: 0.5625rem;
  font-weight: 950;
}

.strategy-filter-state.is-effective {
  color: #047857;
}

.strategy-filter-state.is-covered {
  color: #b45309;
}

.strategy-enabled-count {
  color: #237a55;
  font-variant-numeric: tabular-nums;
}

.strategy-filter-description {
  display: -webkit-box;
  overflow: hidden;
  min-height: 1.25rem;
  margin-top: 0.45rem;
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 1.25rem;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.strategy-filter-quick {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
  margin-top: 0.55rem;
}

.strategy-filter-quick > div {
  border-radius: 0.65rem;
  background: #f7f7f5;
  padding: 0.45rem 0.55rem;
}

.strategy-filter-quick dt {
  color: #94a3b8;
  font-size: 0.5625rem;
  font-weight: 800;
}

.strategy-filter-quick dd {
  overflow: hidden;
  margin-top: 0.15rem;
  color: #334155;
  font-size: 0.6875rem;
  font-weight: 950;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.strategy-filter-chevron {
  display: flex;
  width: 1.8rem;
  height: 1.8rem;
  flex: none;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #f3f3f0;
  color: #68686d;
}

.strategy-filter-chevron svg {
  width: 0.9rem;
  transition: transform 180ms ease;
}

.strategy-filter-card[open] .strategy-filter-chevron svg {
  transform: rotate(180deg);
}

.strategy-filter-detail {
  border-top: 1px solid #ececea;
  background: #f7f7f5;
  padding: 0.9rem 1rem 1rem;
}

.strategy-filter-detail dl {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
}

.strategy-filter-detail dt {
  color: #94a3b8;
  font-size: 0.5625rem;
  font-weight: 800;
}

.strategy-filter-detail dd {
  overflow: hidden;
  margin-top: 0.15rem;
  color: #334155;
  font-size: 0.625rem;
  font-weight: 950;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.strategy-filter-detail p {
  margin-top: 0.75rem;
  color: #64748b;
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 1.5;
}

.strategy-filter-detail p.is-covered {
  color: #b45309;
}

.strategy-more-modules {
  display: flex;
  min-height: 2.8rem;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 0.65rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 0.8rem;
  background: #fff;
  color: #242427;
  font-size: 0.6875rem;
  font-weight: 900;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);
}

.strategy-more-modules:hover {
  background: #f8f8f6;
}

button:focus-visible,
summary:focus-visible,
a:focus-visible {
  outline: 3px solid rgba(245, 158, 11, 0.38);
  outline-offset: 2px;
}

@media (min-width: 640px) {
  .strategy-hero {
    padding: 1.75rem;
  }
  .strategy-overview {
    grid-template-columns: minmax(0, 1.15fr) minmax(17rem, 0.85fr);
    align-items: stretch;
    gap: 1.25rem;
  }
  .strategy-process {
    border-radius: 1rem;
  }
  .strategy-process-summary {
    padding-right: 1.1rem;
    padding-left: 1.1rem;
  }
  .strategy-process-body {
    padding: 0.9rem 1.1rem 1.1rem;
  }
  .strategy-flow {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .strategy-category-nav {
    display: flex;
  }
  .strategy-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
    overflow: visible;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }
  .strategy-filter-card {
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 1rem;
    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.04);
  }
  .strategy-filter-card + .strategy-filter-card {
    border-top: 1px solid rgba(15, 23, 42, 0.08);
  }
}
@media (max-width: 380px) {
  .strategy-summary-grid {
    gap: 0.35rem;
  }
  .strategy-summary-grid > div,
  .strategy-stage {
    padding: 0.6rem;
  }
  .strategy-stage {
    align-items: flex-start;
  }
}
@media (prefers-reduced-motion: reduce) {
  .strategy-page,
  .strategy-meter__remaining {
    animation: none;
    transition: none;
  }
  .strategy-filter-card,
  .strategy-category-nav button,
  .strategy-note summary svg,
  .strategy-process-summary svg,
  .strategy-filter-chevron svg {
    transition: none;
  }
}
@keyframes strategy-page-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`],
})
export class PageFiltersComponent implements OnInit {
    public loading: boolean = true;
    public strategy: any = null;
    public loadError: string = '';
    public selectedCategoryKey: string = 'all';
    public showAllModules: boolean = false;
    public readonly modulePreviewLimit: number = 6;
    public filters: any = {
        modules: [],
        categories: [],
        active_categories: [],
        active_modules: []
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow('/access');
        if (!allowed) return;
        await this.load();
    }

    private normalizeFilters(value: any) {
        const filters = value || { modules: [], categories: [] };
        filters.modules = filters.modules || [];
        filters.categories = filters.categories || [];
        filters.active_categories = filters.categories
            .map((category: any) => ({
                ...category,
                modules: (category.modules || [])
                    .filter((module: any) => !!module.enabled)
                    .map((module: any) => ({
                        ...module,
                        category_key: category.category_key,
                        category_name: category.name
                    }))
            }))
            .filter((category: any) => category.modules.length > 0);
        filters.active_modules = filters.active_categories.reduce(
            (modules: any[], category: any) => modules.concat(category.modules),
            []
        );
        const selectedExists = this.selectedCategoryKey === 'all'
            || filters.active_categories.some(
                (category: any) => category.category_key === this.selectedCategoryKey
            );
        if (!selectedExists) this.selectedCategoryKey = 'all';
        return filters;
    }

    public async load() {
        this.loading = true;
        this.loadError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('overview');
            if (code !== 200) {
                this.loadError = data.message || '번호 전략을 불러오지 못했습니다.';
                return;
            }
            this.strategy = data.strategy || null;
            this.filters = this.normalizeFilters(data.filters);
            if (!this.strategy) {
                this.loadError = '번호 전략을 준비하고 있습니다. 잠시 후 다시 시도해주세요.';
            }
        } catch (error) {
            this.loadError = '연결을 확인한 뒤 다시 시도해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async selectCategory(categoryKey: string) {
        this.selectedCategoryKey = categoryKey || 'all';
        this.showAllModules = false;
        await this.service.render();
    }

    public visibleModules() {
        if (this.selectedCategoryKey === 'all') {
            return this.filters.active_modules || [];
        }
        const category = (this.filters.active_categories || []).find(
            (item: any) => item.category_key === this.selectedCategoryKey
        );
        return category?.modules || [];
    }

    public displayedModules() {
        const modules = this.visibleModules();
        return this.showAllModules ? modules : modules.slice(0, this.modulePreviewLimit);
    }

    public hasHiddenModules() {
        return !this.showAllModules && this.visibleModules().length > this.modulePreviewLimit;
    }

    public async toggleModuleList() {
        this.showAllModules = !this.showAllModules;
        await this.service.render();
        if (!this.showAllModules) {
            document.getElementById('active-filter-section')?.scrollIntoView({
                behavior: 'auto',
                block: 'start'
            });
        }
    }

    public selectedCategoryName() {
        if (this.selectedCategoryKey === 'all') return '모든 조건';
        const category = (this.filters.active_categories || []).find(
            (item: any) => item.category_key === this.selectedCategoryKey
        );
        return category?.name || '모든 조건';
    }

    public percentage(value: any, digits: number = 2) {
        return new Intl.NumberFormat('ko-KR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: digits
        }).format(Number(value || 0)) + '%';
    }

    public remainingPercent() {
        return Math.max(0, Math.min(100, 100 - Number(this.filters?.reduction_percent || 0)));
    }

    public historicalPassCount() {
        return Math.max(
            0,
            Number(this.filters?.historical_draw_count || 0)
                - Number(this.filters?.historical_rejected_draw_count || 0)
        );
    }

    public historicalBlockedPercent() {
        const total = Number(this.filters?.historical_draw_count || 0);
        if (!total) return 0;
        return Number(this.filters?.historical_rejected_draw_count || 0) / total * 100;
    }

    public historicalPassPercent() {
        return Math.max(0, 100 - this.historicalBlockedPercent());
    }

    public marginalCount(module: any) {
        return Number(module?.analysis?.marginal_rejected_combinations || 0);
    }

    public isAdmin() {
        return this.service.auth.session?.role === 'admin';
    }

    public trackByCategoryKey(_index: number, category: any) {
        return category?.category_key;
    }

    public trackByFilterKey(_index: number, module: any) {
        return module?.filter_key;
    }
}

export default PageFiltersComponent;